import { render, staticRenderFns } from "./CaSidebar.vue?vue&type=template&id=13f39242&"
import script from "./CaSidebar.vue?vue&type=script&lang=js&"
export * from "./CaSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports